import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { FacadeSesionService } from 'src/app/services/facade-sesion.service';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CatalogoService } from 'src/app/services/catalogo.service';
import { AlertasService } from 'src/app/services/alertas.service';
import { FormUtils } from 'src/app/shared/utils/form-utils';
import { trigger, transition, style, animate, state } from '@angular/animations';
import { Observable, BehaviorSubject, Subscription } from 'rxjs';
import { Catalogo } from 'src/app/models/entities/catalogo';
import { DateUtils } from 'src/app/shared/utils/date-utils';
import { take, map } from 'rxjs/operators';
import { ElementoCatalogo } from 'src/app/models/entities/elemento-catalogo';
import { EstadoRouteService } from 'src/app/services/estado-route.service';

@Component({
  selector: 'administrar-catalogos',
  templateUrl: './administrar-catalogos.component.html',
  styleUrls: ['./administrar-catalogos.component.scss'],
  animations: [
    // the fade-in/fade-out animation.
    trigger('fadeIn', [

      // the "in" style determines the "resting" state of the element when it is visible.
      state('in', style({ opacity: 1 })),

      // fade in when created. this could also be written as transition('void => *')
      transition(':enter', [
        style({ opacity: 0 }),
        animate(300)
      ]),

      // fade out when destroyed. this could also be written as transition('void => *')
      // transition(':leave',
      //   animate(300, style({ opacity: 0 })))
    ])
  ]
})
export class AdministrarCatalogosComponent implements OnInit, OnDestroy {

  @ViewChild('modalEdicion')
  public modal: any;
  public modalActivo: NgbModalRef;
  @ViewChild('modalAgregar')
  public modalAgregar: any;
  public modalActivoAgregar: NgbModalRef;
  @ViewChild('modalAgregarElementoCatalogo')
  public modalAgregarElemento: any;
  public modalActivoAgregarElementoCatalogo: NgbModalRef;
  @ViewChild('modalEditarElementoCatalogo')
  public modalEditarElemento: any;
  public modalActivoEditarElementoCatalogo: NgbModalRef;
  public mostrarCreadorCatalogo: boolean = false;
  public posicionElementoCatalogo: string;
  public catalogos: Catalogo[] = [];
  public suscripcioncatalogos: Subscription;
  public agregarCatalogoForm: FormGroup;
  public edicionCatalogoForm: FormGroup;
  public agregarElementoForm: FormGroup;
  public edicionElementoForm: FormGroup;
  public catalogoEdicionSeleccionado: Catalogo;
  public elementoEdicionSeleccionado: ElementoCatalogo;
  public catalogo: ElementoCatalogo[] = [];
  public elementoAgregado: ElementoCatalogo = null;
  public catalogoSeleccionado$: BehaviorSubject<Catalogo> = new BehaviorSubject<Catalogo>(null);
  public llavesDeObjeto = Object.keys;
  public readonly fechaActual: number = new Date().getTime();

  public cols = [
    { field: 'nombre', header: 'Nombre' },
    { field: 'descripcion', header: 'Descripción' }
  ];

  public columnas = [
    { field: 'key', header: 'Key' },
    { field: 'nombre', header: 'Nombre' },
    { field: 'descripcion', header: 'Descripción' },
    { field: 'fechaCreacion', header: 'Fecha creación' },
    { field: 'fechaActualizacion', header: 'Fecha actualización' },
    { field: 'activo', header: 'Activo' }
  ];

  public catalogoSeleccionado: boolean = false;
  public catalogos$: Observable<boolean>;
  public mostrarBtnCatalogos$: Observable<boolean>;

  public constructor(
    private ngbModalService: NgbModal,
    private catalogoService: CatalogoService,
    private formBuilder: FormBuilder,
    private alertasService: AlertasService,
    public formUtils: FormUtils,
    public dateUtils: DateUtils,
    private estadoRouteService: EstadoRouteService,
    private facadeSesionService: FacadeSesionService
  ) { }

  public ngOnInit(): void {
    this.facadeSesionService.breadcrumbService.actualizarBreadcrumbFuncionalidad('Administración de catálogos');
    this.mostrarBtnCatalogos$ = this.estadoRouteService.mostrarBtnCatalogos$.asObservable();
    this.catalogos$ = this.estadoRouteService.catalogos$.asObservable();
    this.catalogos$.subscribe(cat => this.catalogoSeleccionado = cat);
    this.inicializarCreacionCatalogoForm();
    this.inicializarCreacionElementoForm();
    this.suscripcioncatalogos = this.catalogoService.obtenerListaDeCatalogos().pipe(
      take(1),
      map((catalogos: Catalogo[]) =>
        catalogos.map((c: Catalogo) => ({
          ...c,
          catalogo: c.catalogo && c.catalogo.length > 0 ? c.catalogo.map((n, i) => ({ ...n, key: i.toString() } as ElementoCatalogo)) : []
        }))
      )
    ).subscribe(
      (catalogos: Catalogo[]) => {
        this.catalogos = catalogos;
      }
    );
  }

  inicializarCreacionCatalogoForm() {
    this.agregarCatalogoForm = this.formBuilder.group({
      identificador: new FormControl('', [Validators.required]),
      nombre: new FormControl('', [Validators.required]),
      descripcion: new FormControl('', [Validators.required]),
    });
  }

  inicializarCreacionElementoForm() {
    this.agregarElementoForm = this.formBuilder.group({
      nombre: new FormControl('', [Validators.required]),
      descripcion: new FormControl('', [Validators.required]),
    });
  }

  public verCatalogo(catalogo: Catalogo): void {
    this.estadoRouteService.mostrarBtnRetroceder$.next(false);
    this.estadoRouteService.mostrarBtnCatalogos$.next(true);
    this.estadoRouteService.catalogos$.next(true);
    if (catalogo.catalogo === undefined) {
      catalogo.catalogo = [];
    }
    this.catalogoSeleccionado$.next(catalogo);
  }

  public abrirModalEdicionCatalogo(catalogo: Catalogo): void {
    this.catalogoEdicionSeleccionado = catalogo;
    this.edicionCatalogoForm = this.formBuilder.group({
      nombre: new FormControl(catalogo.nombre, [Validators.required]),
      descripcion: new FormControl(catalogo.descripcion, [Validators.required]),
    });
    this.modalActivo = this.ngbModalService.open(this.modal, {
      centered: true,
      windowClass: 'modal-confirmacion',
      backdrop: 'static',
      keyboard: false
    });
  }

  public actualizarCatalogo() {
    this.catalogoEdicionSeleccionado.nombre = this.edicionCatalogoForm.value.nombre;
    this.catalogoEdicionSeleccionado.descripcion = this.edicionCatalogoForm.value.descripcion;
    this.cerrarModalEdcion();
    return this.catalogoService.update(this.catalogoEdicionSeleccionado.key, this.catalogoEdicionSeleccionado);
  }

  public cerrarModalEdcion(): void {
    this.modalActivo.close();
  }

  public abrirModalAgregarCatalogo(): void {
    this.modalActivoAgregar = this.ngbModalService.open(this.modalAgregar, {
      centered: true,
      windowClass: 'modal-confirmacion',
      backdrop: 'static',
      keyboard: false
    });
  }

  public agregarCatalogo() {
    let catalogo: any = {
      key: this.agregarCatalogoForm.value.identificador,
      nombre: this.agregarCatalogoForm.value.nombre,
      descripcion: this.agregarCatalogoForm.value.descripcion,
    };
    let catalogoTabla: any = {
      key: this.agregarCatalogoForm.value.identificador,
      nombre: this.agregarCatalogoForm.value.nombre,
      descripcion: this.agregarCatalogoForm.value.descripcion,
    };
    this.catalogos.push(catalogoTabla);
    this.cerrarModalAgregar();
    this.alertasService.mostrarAlerta('success', 'Catalogo agregado.');
    return this.catalogoService.saveCatalogo(catalogo);
  }

  public cerrarModalAgregar(): void {
    this.modalActivoAgregar.close();
  }

  public abrirModalAgregarElemento(): void {
    this.catalogo = this.catalogoSeleccionado$.value.catalogo;
    this.modalActivoAgregarElementoCatalogo = this.ngbModalService.open(this.modalAgregarElemento, {
      centered: true,
      windowClass: 'modal-confirmacion',
      backdrop: 'static',
      keyboard: false
    });
  }

  public agregarElementoCatalogo() {
    let key: string = '';
    if (this.catalogo.length === 0) {
      key = '0';
    } else {
      key = this.catalogoSeleccionado$.value.catalogo.length.toString();
    }
    let keyCatalogo = this.catalogoSeleccionado$.value.key;
    let elemento: any = {
      nombre: this.agregarElementoForm.value.nombre,
      descripcion: this.agregarElementoForm.value.descripcion,
      activo: true,
      fechaActualizacion: this.fechaActual,
      fechaCreacion: this.fechaActual
    };
    delete elemento.key;
    let elementoTabla: any = {
      key: key,
      nombre: this.agregarElementoForm.value.nombre,
      descripcion: this.agregarElementoForm.value.descripcion,
      activo: true,
      fechaActualizacion: this.fechaActual,
      fechaCreacion: this.fechaActual
    };
    this.catalogo.push(elementoTabla);
    this.cerrarModalAgregarElemento();
    this.alertasService.mostrarAlerta('success', 'Elemento agregado.');
    return this.catalogoService.save(keyCatalogo, key, elemento);
  }

  public cerrarModalAgregarElemento(): void {
    this.modalActivoAgregarElementoCatalogo.close();
  }

  public abrirModalEdicionElemento(catalogo: ElementoCatalogo): void {
    this.elementoEdicionSeleccionado = catalogo;
    this.edicionElementoForm = this.formBuilder.group({
      habilitado: new FormControl(catalogo.activo),
      nombre: new FormControl(catalogo.nombre, [Validators.required]),
      descripcion: new FormControl(catalogo.descripcion, [Validators.required]),
    });
    this.modalActivoEditarElementoCatalogo = this.ngbModalService.open(this.modalEditarElemento, {
      centered: true,
      windowClass: 'modal-confirmacion',
      backdrop: 'static',
      keyboard: false
    });
  }

  public edicionElementoCatalogo() {
    let keyCatalogo = this.catalogoSeleccionado$.value.key;
    this.elementoEdicionSeleccionado.activo = this.edicionElementoForm.value.habilitado;
    this.elementoEdicionSeleccionado.nombre = this.edicionElementoForm.value.nombre;
    this.elementoEdicionSeleccionado.descripcion = this.edicionElementoForm.value.descripcion;
    this.elementoEdicionSeleccionado.fechaActualizacion = this.fechaActual;
    this.cerrarModalEditarElemento();
    return this.catalogoService.updateElemento(keyCatalogo, this.elementoEdicionSeleccionado.key, this.elementoEdicionSeleccionado);
  }

  public cerrarModalEditarElemento(): void {
    this.modalActivoEditarElementoCatalogo.close();
  }

  public ngOnDestroy(): void {
    this.estadoRouteService.mostrarBtnCatalogos$.next(false);
    this.estadoRouteService.catalogos$.next(false);
    if (this.suscripcioncatalogos) {
      this.suscripcioncatalogos.unsubscribe();
    }
  }

}
